import React from "react";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import ACCESS from "../../../ACCESS.js";

class FacturasEnviadas extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: "facturacion/filter",
        deleteUrl: false,
        deleteField: false,
        modUrl: "/Guias/EnvioFacturas",
      },
      TableOp.Table(
        "Guias Enviadas",
        [
          { label: "Folio", id: "id" },
          // { label: "# de guias", id: "numero_guias" },
          { label: "Estatus", id: "status_text" },
          // { label: "Folios de las guias", id: "guias_folios" },
          { label: "Fecha de Enviado", id: "createdAt" },
          { label: "Sucursal", id: "sucursal" },
          { label: "Usuario", id: "usuario" },
        ],
        [
          { id: "folio", icon: "edit", tooltip: 'Ver Folio', 
            access: [ACCESS.ENVIO_GUIAS_CYC.VER_TODOS_LOS_FOLIOS, ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_CREADOS_POR_EL_USUARIO, ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_SUCURSAL_DEL_USUARIO] },
          { id: "review", icon: "visibility", tooltip: 'Revisar Folio', access: [ACCESS.ENVIO_GUIAS_CYC.RECIBIR_FOLIO] },
        ]
      )
    );
    this.table();
  }

  navegarFacturas = () => {
    this.props.history.push(`/Guias/EnvioFacturas`);
  };

  action = (id, row) => {
		if (id === 'folio') {
			this.props.history.push(`${this.config.modUrl}/${row.id}`)
		} else if (id === 'review') {
      if (row.status !== 1) {
        this.props.history.push(`/Cobranza/RecibirGuia/${row.id}`);
      }
		}
	}


  render() {
    const { hasAccess } = this.context
    return (
      <div>
        <div style={{ padding: "10px" }}>
        {
          hasAccess(ACCESS.ENVIO_GUIAS_CYC.CREAR_FOLIO) && (
          <Button
            onClick={this.navegarFacturas}
            color="primary"
            variant="contained"
          >
            Crear Nuevo Folio
          </Button>)
        }
        </div>
        <this.TableRender />
      </div>
    );
  }
}

export default withRouter(FacturasEnviadas);
